import type { JSX } from 'react';

interface CourseDetailsProps {
  title: string;
  eligibility: string;
  duration: string;
  syllabus: string[];
}

export default function CourseDetails({ title, eligibility, duration, syllabus }: CourseDetailsProps): JSX.Element {
  return (
    <div className="rounded-md bg-white p-6 shadow-sm ring-1 ring-neutral-200">
      <h2 className="text-lg font-bold text-neutral-900">{title}</h2>

      <p className="mt-3 text-neutral-700">
        <span className="font-semibold">Eligibility:</span> {eligibility}
      </p>
      <p className="mt-1 text-neutral-700">
        <span className="font-semibold">Duration:</span> {duration}
      </p>

      <p className="mt-3 font-semibold text-neutral-900">Syllabus:</p>
      <ul className="mt-1 list-inside list-disc text-neutral-700">
        {syllabus.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </div>
  );
}
